import React from 'react';
import Modal from './Modal.js';
import Speech from './Reader/Speech/Speech';
import WordInterventionModal from './WordInterventionModal';
import {interventionType} from "../constants/interventionSelectionConstants";
import {getEndOfClap,speakInterventionLeadIn} from "../services/interventionSelection";
import {getUserData} from '../services/API';
import {COPY_STRINGS} from '../constants/translatedCopy';
import {listen} from '../services/Listen';

const repeatStates = {
  introduction: 'introduction',
  soundout: 'soundout',
  definition: 'definition',
  repeat: 'repeat',
  listen: 'listen',
  feedback: 'feedback',
  done: 'done',
};

export default class RepeatAfterMe extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      numberOfTimesToTry: 2,
      currentNumberOfTries: 1,
      currentInterventionState: repeatStates.introduction,
      wordDefinition: null,
      numberOfSyllables: 0,
      currentSyllable: -1,
      phonemesToSpeak: [],
      matchTimeout: null,
      wordImage: null,
    };
  }

  componentDidMount(){
    this.props.speech.setOnSpeechStart(null);
    this.initWordMetadata();
    this.readIntroText();
  }

  componentDidUpdate(prevProps,prevState){
    if(this.state.currentInterventionState !== prevState.currentInterventionState){
      switch(this.state.currentInterventionState) {
        case(repeatStates.introduction):
          this.readIntroText();
          break;

        case(repeatStates.soundout):
          this.handleSoundout();
          break;

        case(repeatStates.definition):
          this.handleDefinition();
          break;

        case(repeatStates.repeat):
          this.handleRepeat();
          break;

        case(repeatStates.listen):
          this.handleListen();
          break;

        case(repeatStates.feedback):
          this.handleFeedback();
          break;

        case(repeatStates.done):
          this.props.stopIntervention();
          break;

        default:
          break;
      }
    }
  }

  //If there isn't a definition, skip
  handleDefinition(){
    if(this.state.wordDefinition){
      let callback = (
        function(event){
          this.setState({currentInterventionState: repeatStates.repeat});
        }
      ).bind(this);

      if(getUserData().bilingualMode){
        this.props.speech.speak({textToSpeak: this.props.wordToPractice, skipTranslation: true});
        this.props.speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.means}, undefined, undefined, true);
        this.props.speech.speak({textToSpeak: this.state.wordDefinition, skipTranslation: true, onEnd: callback});
      } else {
        let textToSpeak = `"${this.props.wordToPractice}"` + " " + COPY_STRINGS.intervention_strings.means + ": " + this.state.wordDefinition;
        this.props.speech.speak({textToSpeak: textToSpeak, onEnd: callback});
      }
    }else{
      this.setState({currentInterventionState: repeatStates.repeat});
    }
  }

  handleFeedback(){
    let props = {};
    props.skipAvatar = false;
    if(this.state.currentNumberOfTries < this.state.numberOfTimesToTry){
      props.textToSpeak = COPY_STRINGS.intervention_strings.feedbackUtterances[this.state.currentNumberOfTries];
    } else {
      props.textToSpeak = getEndOfClap(this.props.readingLevel);
    }

    props.onEnd = (
      function(event){
        this.setState({currentInterventionState: repeatStates.repeat});
      }
    ).bind(this);
    this.props.speech.speak(props);
  }

  onSyllableEnd(){
    let syllable = this.state.currentSyllable;
    if(syllable < this.state.numberOfSyllables-1){
      let props = {};
      syllable++;
      this.setState({currentSyllable: syllable});

      props.skipAvatar = false;
      props.textToSpeak = this.state.phonemesToSpeak[syllable];
      props.skipTranslation = true;
      props.passThroughSpeechTags = true;
      props.onEnd = this.handleListen.bind(this);
      this.props.speech.speak(props);
    }else {
      this.props.speech.speak({
        textToSpeak: this.props.wordToPractice + ".  <break time = \"2.5s\"/>",
        passThroughSpeechTags: true,
        skipTranslation: true,
        onEnd: () => {
          this.setState({
            currentSyllable: -1,
            currentInterventionState: repeatStates.feedback,
          });
        },
      });
    }
  }

  handleSoundout(){
    if(this.state.currentSyllable === -1){
      this.setState({
        currentSyllable: 0,
      });
    }

    let props = {};

    props.skipAvatar = false;
    props.textToSpeak = this.state.phonemesToSpeak[0];
    props.skipTranslation = true;
    props.passThroughSpeechTags = true;
    props.onEnd = (()=>{
      this.setState({currentInterventionState: repeatStates.listen});
    }).bind(this);

    this.props.speech.speak(props);
  }

  handleRepeat(){
    if (this.state.currentNumberOfTries >= this.state.numberOfTimesToTry){
      this.setState({
        currentInterventionState: repeatStates.done,
        currentNumberOfTries: 0,
      });
      this.props.closeModal(true);
    }else{
      let props = {};
      props.skipAvatar = false;
      props.passThroughSpeechTags = true;
      if (this.state.currentNumberOfTries === 1){
        // TODO: we are temporarily simplifying the clap. Leave the original in until we settle on an approach
        //props.textToSpeak = "Wait for me to say the word, then repeat while clapping out each syllable.<break time=\"0.1s\"/>";
        props.textToSpeak = `${COPY_STRINGS.intervention_strings.repeat_after_me}: "${this.props.wordToPractice}".`;
      } else{
        props.textToSpeak = COPY_STRINGS.intervention_strings.show_again;
      }
      props.onEnd = (()=>{
        this.setState({currentInterventionState: repeatStates.listen});
      });
      this.props.speech.speak(props);
      let tries = this.state.currentNumberOfTries;
      tries++;
      this.setState({
        currentNumberOfTries: tries
      });
    }
  }

  handleListen(){
    listen({
      speech: this.props.speech,
      targetWord: this.props.wordToPractice,
      interventionType: interventionType.clap,
      closeText: "",
      endOfPhrase: true,
      callback: (()=>{
        this.setState({currentInterventionState: repeatStates.done});
      }).bind(this)
    });
  }


  readIntroText(){
    let onEnd = (
      function(event){
        this.setState({currentInterventionState: repeatStates.definition});
      }
    ).bind(this);
    speakInterventionLeadIn(this.props.speech, interventionType.clap,this.props.wordToPractice, onEnd);
  }

  initWordMetadata(){
    let currentWord = this.props.wordToPractice;
    const meta = this.props.wordMetadata;
    currentWord = currentWord.toUpperCase();

    try {
      if (meta) {
        let newState = {};

        //First get the soundout text
        let phonemeString = meta.PHON;
        if(phonemeString && (phonemeString !== " ")){
          phonemeString = phonemeString.replace(/0/g, "O");
          let phonemes = phonemeString.split("/");
          let soundOutText = [];
          for(let i=0;i<phonemes.length;i++)
          {
            // TODO: we are temporarily simplifying the clap. Leave the original in until we settle on an approach
            //###soundOutText.push("<mark name=\"gesture:SlowClap\"/><break time=\"0.8s\"/><mark name=\"event:clap\"/><phoneme alphabet=\"ipa\" ph=\"" + phonemes[i] + "\">xx</phoneme><break time=\"0.25s\"/>")
            soundOutText.push("<phoneme alphabet=\"ipa\" ph=\"" + phonemes[i] + "\">xx</phoneme><break time=\"0.25s\"/>")
            //###for testing in Polly console: <speak><phoneme alphabet="ipa" ph="sˈɛ/pɹət">xx</phoneme><break time="0.25s"/></speak>)
          }
          newState.phonemesToSpeak = soundOutText;
          newState.numberOfSyllables = phonemes.length
        }else{
          //TODO: If we don't have something to sound out, we're hosed. Figure out how to handle this.
          throw new Error("NO PHONEMES FOR CLAP");
        }

        //Next, get the definition. If it's undefined, we handle it below
        newState.wordDefinition = meta.DEFINITION && meta.DEFINITION.default;

        //Lastly, get the word image. If there isn't one, don't mutate state and use the default
        if(meta.IMG_URL){
          newState.wordImage = meta.IMG_URL;
        }

        this.setState(newState);
      } else {
        throw new Error(`No metadata in props for ${currentWord}`);
      }
    } catch (err) {
      console.log("err",err)
    }
  }

  render() {
    const title = COPY_STRINGS.intervention_strings.lets_read_word + ": ";
    const currentWord = this.props.wordToPractice;
    let instructions = (<div>{title}</div>);

    let image = this.state.wordImage;

    return (
      <div>
        <Modal>
          <WordInterventionModal
            word={currentWord}
            instructions={instructions}
            icon={image}
            useWordIcon={true}
          />
        </Modal>
      </div>
    );
  }
}
